import "../css/Team.css";

const team = [
  {
    name: "Elena Moreau",
    role: "Founder · Creative Director",
    img: "https://images.pexels.com/photos/3997983/pexels-photo-3997983.jpeg",
  },
  {
    name: "Isabella Cruz",
    role: "Senior Stylist",
    img: "https://images.pexels.com/photos/3997992/pexels-photo-3997992.jpeg",
  },
  {
    name: "Noah Bennett",
    role: "Color Specialist",
    img: "https://images.pexels.com/photos/3997991/pexels-photo-3997991.jpeg",
  },
  {
    name: "Amelia Wright",
    role: "Skin & Facial Expert",
    img: "https://images.pexels.com/photos/3997990/pexels-photo-3997990.jpeg",
  },
];

const Team = () => {
  return (
    <main className="salon-team">

      {/* HERO */}
      <section className="team-hero">
        <h1>The Team</h1>
        <p>
          Artists, stylists, and specialists<br />
          guided by craft and care.
        </p>
      </section>

      {/* TEAM GRID */}
      <section className="team-grid">
        {team.map((member, index) => (
          <div className="team-member" key={index}>
            <div
              className="member-image"
              style={{ backgroundImage: `url(${member.img})` }}
            />
            <h3>{member.name}</h3>
            <span>{member.role}</span>
          </div>
        ))}
      </section>

      {/* CLOSING */}
      <section className="team-closing">
        <p>
          Expertise feels different<br />
          when delivered with intention.
        </p>
      </section>

    </main>
  );
};

export default Team;
